import { render } from "./agreement1-mobile.vue?vue&type=template&id=0ed698d2"
import script from "./agreement1-mobile.vue?vue&type=script&lang=js"
export * from "./agreement1-mobile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__